<template>
  <div>
    <template v-if="!usage">
      <div class="qrcode" info="二维码">
        <div class="inner">
          <img :src="src" alt="二维码" />
        </div>
      </div>
    </template>
    <template v-else>
      <div class="usage_qr" info="二维码">
        <div class="inner">
          <img src="../assets/img/qr_mask.png" alt="二维码" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: "",
    },
    usage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.qrcode,
.usage_qr {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  width: 135px;
  height: 135px;
  position: relative;
  text-align: center;
  font-size: 24px;
  transition: all 0.3s;
  background-color: #fff;

  .inner {
    position: absolute;
    left: 5px;
    top: 5px;
    width: calc(100% - 10px);
    height: calc(100% - 10px);
    background: #ffffff;
    z-index: 2;
    box-sizing: border-box;

    img {
      width: 100%;
      height: 100%;
      border: 1px solid rgba(5, 5, 5, 0.06);
      border-radius: 8px;
      padding: -10px;
      background-color: transparent;
      overflow: hidden;
      color: rgba(0, 0, 0, 0.88);
      box-sizing: border-box;
    }
  }
}

.qrcode {
  border: 2px solid var(--primary-color);
  &::before,
  &::after {
    content: "";
    position: absolute;
    top: -10px;
    left: -10px;
    right: -10px;
    bottom: -10px;
    border: 2px solid var(--primary-color);
    transition: all 0.5s;
    border-radius: 8px;
    animation: clippath 3s infinite linear;
  }

  &::after {
    animation: clippath 3s infinite -1.5s linear;
  }

  @keyframes clippath {

    0%,
    100% {
      clip-path: inset(0 0 98% 0);
    }

    25% {
      clip-path: inset(0 98% 0 0);
    }

    50% {
      clip-path: inset(98% 0 0 0);
    }

    75% {
      clip-path: inset(0 0 0 98%);
    }
  }
}
</style>
